import { put, call, getContext } from 'redux-saga/effects';
import { sagaRequest, COOKIES_ERROR, clearCookies, checkCookiesEnabled, } from '@ovpn-ui/utils';
import * as routines from './auth.routines';
export function* checkCookies() {
    const cookiesEnabled = yield call(checkCookiesEnabled);
    if (!cookiesEnabled) {
        const onError = yield getContext('onError');
        onError(COOKIES_ERROR);
    }
    return cookiesEnabled;
}
export function* getProductTokenSaga(authorizeRequest, ...params) {
    yield sagaRequest(authorizeRequest, ...params)
        .bind(routines.getProductToken)
        .mapFailure(null)
        .retry({ times: 9, exponential: true, delay: 50 })
        .run();
}
export function* clearAuthSaga() {
    yield call(clearCookies);
    yield put(routines.refreshToken.failure());
}
export function* refreshTokenSaga(refreshTokenRequest) {
    yield sagaRequest(refreshTokenRequest).run();
}
export function getRefreshDelayForToken(tokenExp) {
    const MAX_SAFE_INTEGER = Math.pow(2, 31) - 1;
    const MIN_REFRESH_DELAY = 10000;
    const nowTimestamp = new Date();
    const expTimestamp = new Date(tokenExp * 1000);
    const refreshDelay = Math.min((expTimestamp.valueOf() - nowTimestamp.valueOf()) / 2, MAX_SAFE_INTEGER);
    return {
        refreshDelay,
        shouldLogout: refreshDelay <= MIN_REFRESH_DELAY,
    };
}
